var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-6 col-sm-4 col-md-3"},[_c('h4',[_vm._v(_vm._s(_vm.stat.value))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.stat.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }